import React, { Component } from 'react';
import { Accordion, Card, Button, Table, Pagination } from 'react-bootstrap';
import { translate } from "react-i18next";
import { getURL } from '../../backend/Backend';
import {GREEN_LIGHT, RED_LIGHT} from "../../backend/Colors";




class CommentPollResult extends Component {

    constructor(props) {
        super(props);

        this.loadCommentPolls = this.loadCommentPolls.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.state = {
            pollResults:[],
            activePage: 1,
            totalPages: 0
        };
    }

    async loadCommentPolls (){
      let page = this.state.activePage
       
        const response = await fetch(getURL(`commentpoll/load/${this.props.commentId}/${this.props.response}/${page - 1}`));
    
        const json = await response.json();
        let oldState = this.state;
      
        this.setState({ 
            ...oldState,
          pollResults: json.content,
          totalPages: json.totalPages,
          activePage: page
         });
    }

    async pageChanged(e) {
      this.loadItems(e.target.text);
    }

    async loadItems(page) {
      if (!page) {
        return;
      }
      if ("<" === page) {
        page = --this.state.activePage;
      }
      if (">" === page) {
        page = ++this.state.activePage;
      }
      console.log("loadItems page : "+page);
      const response = await fetch(getURL(`commentpoll/load/${this.props.commentId}/${this.props.response}/${page - 1}`));
      const json = await response.json();
      let oldState = this.state;
      this.setState({ 
        ...oldState,
      pollResults: json.content,
      totalPages: json.totalPages,
      activePage: page
     });
    }
   
    render() {
        if(!this.props.count || this.props.count === 0){
            return ""; 
        }
        let textCss = this.props.response === 'YES' ? GREEN_LIGHT: RED_LIGHT; //"text-success":"text-danger" 
        const { t } = this.props;
        return (
          <div className=" justify-content-between d-relative  ml-5">
            <Accordion defaultActiveKey="1">
              <Card border="white">
                <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={this.loadCommentPolls} className="text-primary text-left">
                <i style={{"color":textCss}} className={" fa fa-users s24 mr-2 ml-1"}></i> {this.props.count }
                  </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body >
                  <Table responsive size="sm">
                  <tbody>
                    {this.state.pollResults.map((u,i) =>
                      <tr key={i}>
                        <td>
                           {u.name}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <Pagination onClick={this.pageChanged}>
                  {this.state.activePage > 1 ?
                    <Pagination.Item>{'<'}</Pagination.Item>
                    : ""
                  }

                  {[...Array(this.state.totalPages).keys()].map(i => {
                    return <Pagination.Item active={(i + 1) === this.state.activePage} key={i}>{i + 1}</Pagination.Item>
                  })
                  }
                  {this.state.activePage < this.state.totalPages ?
                    <Pagination.Item>{'>'}</Pagination.Item>
                    : ""
                  }

                </Pagination>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
    
            </Accordion>
          </div>
        );
    }

}

export default translate("translations")(CommentPollResult);